/* TAYRO — live-site features for theme 11: cart drawer, predictive search, toast, quick add, thank-you popup */
(function () {
  'use strict';

  var FREE_SHIP = 75;
  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) { return '$' + (Number(cents || 0) / 100).toFixed(2); }

  /* ── TOAST ── */
  var toastTimer;
  window.toast = function (msg) {
    var el = $('toast'), m = $('toast-msg');
    if (!el || !m) return;
    m.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2600);
  };

  /* ── CART ── */
  // Light / Dark Colors versions read as one name; options show Color first, then Size
  function lineLabel(item) {
    var opts = (item.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; });
    var name = item.product_title || '';
    var hasColor = opts.some(function (o) { return /colou?r/i.test(o.name); });
    if (hasColor && name.indexOf(' - ') > 0) name = name.substring(0, name.indexOf(' - '));
    opts = opts.slice().sort(function (a, b) { return (/colou?r/i.test(b.name) ? 1 : 0) - (/colou?r/i.test(a.name) ? 1 : 0); });
    return { name: name, variant: opts.map(function (o) { return o.value; }).join(' / ') };
  }

  function paintCount(n) {
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      var c = a.querySelector('.cart-count');
      if (n > 0) {
        if (!c) { c = document.createElement('span'); c.className = 'cart-count'; a.appendChild(c); }
        c.textContent = n;
      } else if (c) { c.remove(); }
    });
  }

  function render(cart) {
    paintCount(cart.item_count);
    var body = $('cd-body'), foot = $('cd-foot'), ship = $('cd-ship');
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="cd__empty"><p>Your cart is empty.</p><a class="btn btn--ghost" href="/collections/all">Shop the collection</a></div>';
      if (foot) foot.hidden = true;
      if (ship) ship.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var l = lineLabel(item);
      var img = item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(l.name) + '" loading="lazy">' : '';
      return '<div class="cd-item">'
        + '<a class="cd-item__img" href="' + esc(item.url) + '">' + img + '</a>'
        + '<div><a class="cd-item__name" href="' + esc(item.url) + '">' + esc(l.name) + '</a>'
        + (l.variant ? '<div class="cd-item__variant">' + esc(l.variant) + '</div>' : '')
        + '<div><span class="cd-qty"><button type="button" data-cd-change="' + esc(item.key) + '" data-q="' + (item.quantity - 1) + '" aria-label="One less">&minus;</button>'
        + '<span>' + item.quantity + '</span>'
        + '<button type="button" data-cd-change="' + esc(item.key) + '" data-q="' + (item.quantity + 1) + '" aria-label="One more">+</button></span>'
        + '<button type="button" class="cd-remove" data-cd-change="' + esc(item.key) + '" data-q="0">Remove</button></div></div>'
        + '<div class="cd-item__price">' + money(item.final_line_price) + '</div>'
        + '</div>';
    }).join('');
    if (foot) { foot.hidden = false; $('cd-total').textContent = money(cart.total_price); }
    if (ship) {
      var total = cart.total_price / 100, left = FREE_SHIP - total;
      ship.hidden = false;
      $('cd-ship-msg').innerHTML = left > 0
        ? 'Add <b>$' + left.toFixed(2) + '</b> more for free shipping'
        : '<span class="ok">&#10003; You\'ve unlocked free shipping</span>';
      $('cd-ship-bar').style.width = Math.min(100, (total / FREE_SHIP) * 100) + '%';
    }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }
  window.refreshCart = refreshCart;

  window.openCart = function () {
    var d = $('cart-drawer'), o = $('cd-overlay');
    if (!d) { window.location.href = '/cart'; return; }
    refreshCart();
    d.classList.add('on'); if (o) o.classList.add('on');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  window.closeCart = function () {
    var d = $('cart-drawer'), o = $('cd-overlay');
    if (!d) return;
    d.classList.remove('on'); if (o) o.classList.remove('on');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  window.addToCart = function (variantId, name, _cat, _price, btn) {
    if (!variantId) { window.toast('This item is unavailable right now'); return Promise.resolve(); }
    var prev = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d && (d.description || d.message) || 'Could not add to cart.');
      });
    }).then(function () {
      window.toast((name || 'Item') + ' added to cart');
      window.openCart();
    }).catch(function (err) {
      window.toast(err && err.message ? err.message : 'Could not add to cart. Try again.');
    }).then(function () {
      if (btn) { btn.disabled = false; btn.textContent = prev || 'Add to Cart'; }
    });
  };

  function changeLine(key, q) {
    var d = $('cart-drawer');
    if (d) d.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, q) })
    }).then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { window.toast('Could not update the cart. Try again.'); })
      .then(function () { if (d) d.classList.remove('is-busy'); });
  }

  /* ── SEARCH ── */
  var searchOpen = false, debounce;
  function openSearch() {
    var p = $('search-panel'); if (!p) return;
    searchOpen = true;
    p.classList.add('on'); p.setAttribute('aria-hidden', 'false');
    var b = $('search-backdrop'); if (b) b.classList.add('on');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var i = $('search-input'); if (i) i.focus(); }, 250);
  }
  function closeSearch() {
    var p = $('search-panel'); if (!p) return;
    searchOpen = false;
    p.classList.remove('on'); p.setAttribute('aria-hidden', 'true');
    var b = $('search-backdrop'); if (b) b.classList.remove('on');
    document.body.style.overflow = '';
  }
  window.openSearch = openSearch; window.closeSearch = closeSearch;

  function runSearch(q) {
    var out = $('search-results'); if (!out) return;
    if (!q || q.trim().length < 2) { out.innerHTML = ''; return; }
    out.innerHTML = '<div class="sr-loading">Searching…</div>';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        var all = '/search?type=product&q=' + encodeURIComponent(q);
        if (!items.length) {
          out.innerHTML = '<div class="sr-empty">Nothing found for “' + esc(q) + '”. Try another word.</div><a class="btn btn--ghost btn--block sr-viewall" href="' + all + '">Search the whole store</a>';
          return;
        }
        var seen = {}, html = '<div class="sr-label">Products</div>';
        items.forEach(function (p) {
          var t = String(p.title || '');
          if (t.indexOf(' - ') > 0 && /colou?rs?$/i.test(t)) t = t.substring(0, t.indexOf(' - '));
          var k = t.toLowerCase(); if (seen[k]) return; seen[k] = 1;
          var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '" alt="">' : '';
          var price = p.price ? '$' + parseFloat(p.price).toFixed(2).replace(/\.00$/, '') : '';
          html += '<a class="sr-item" href="' + esc(p.url) + '"><span class="sr-thumb">' + img + '</span>'
            + '<span class="sr-info"><span class="sr-title">' + esc(t) + '</span>' + (p.type ? '<span class="sr-meta">' + esc(p.type) + '</span>' : '') + '</span>'
            + (price ? '<span class="sr-price">' + price + '</span>' : '') + '</a>';
        });
        html += '<a class="btn btn--ghost btn--block sr-viewall" href="' + all + '">View all results</a>';
        out.innerHTML = html;
      })
      .catch(function () { out.innerHTML = '<div class="sr-empty">Search is unavailable right now. Press Enter to search the store.</div>'; });
  }

  /* ── CLICKS ── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var open = t.closest('[data-cart-open]');
    if (open && $('cart-drawer')) { e.preventDefault(); window.openCart(); return; }
    if (t.closest('[data-cart-close]')) { window.closeCart(); return; }
    if (t.closest('[data-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-search-close]')) { closeSearch(); return; }
    var ch = t.closest('[data-cd-change]');
    if (ch) { changeLine(ch.getAttribute('data-cd-change'), Number(ch.getAttribute('data-q'))); return; }
    var qa = t.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault(); e.stopPropagation();
      window.addToCart(qa.getAttribute('data-variant-id'), qa.getAttribute('data-title') || 'Item', 'all', 0, qa);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (searchOpen) closeSearch();
    window.closeCart();
  });

  var si = $('search-input');
  if (si) {
    si.addEventListener('input', function (e) {
      clearTimeout(debounce);
      var q = e.target.value;
      debounce = setTimeout(function () { runSearch(q); }, 220);
    });
  }

  /* ── THANK-YOU POPUP after a church nomination ── */
  (function () {
    var KEY = 'tayro_nominated';
    var form = $('church-nomination');
    if (form) form.addEventListener('submit', function () { try { sessionStorage.setItem(KEY, String(Date.now())); } catch (err) {} });
    var modal = $('ty-modal');
    if (!modal) return;
    function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    modal.addEventListener('click', function (e) { if (e.target === modal || (e.target.closest && e.target.closest('[data-ty-close]'))) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var stamp = null;
    try { stamp = sessionStorage.getItem(KEY); } catch (err) {}
    var posted = location.search.indexOf('contact_posted=true') > -1;
    if (stamp && (Date.now() - Number(stamp) < 5 * 60 * 1000) && (posted || !form)) {
      try { sessionStorage.removeItem(KEY); } catch (err) {}
      modal.classList.add('is-open'); document.body.style.overflow = 'hidden';
    }
  })();

  /* Keep the header count right on page load (e.g. after Back) */
  refreshCart();
})();
